import { useEffect, useState } from 'react';
import { useQuery } from '../common';

export function useNameSyncFlow() {
  const [nameSyncFlow, setNameSyncFlow] = useState(false);
  const query = useQuery();

  useEffect(() => {
    // Get state from URL
    const stateFromUrl = query.get('state');
    
    if (stateFromUrl) {
      // Check if it's a name sync flow (starts with 'nameSync_')
      const isNameSync = stateFromUrl.startsWith('nameSync_');
      setNameSyncFlow(isNameSync);
    }
  }, [query]);

  return nameSyncFlow;
}
